import { ORDER_SIDE, ORDER_TYPE } from "../../shared";
import { TAKER_OR_MAKER } from "../../untrustedApi/types";
import z from "zod";

export const SPOT_ORDER_STATUS_FILTER = {
  OPEN: "open",
  CLOSED: "closed",
  ALL: "all",
} as const;
export type SPOT_ORDER_STATUS_FILTER = (typeof SPOT_ORDER_STATUS_FILTER)[keyof typeof SPOT_ORDER_STATUS_FILTER];
export type SpotOrderStatusFilter = (typeof SPOT_ORDER_STATUS_FILTER)[keyof typeof SPOT_ORDER_STATUS_FILTER];

export const SpotOrderTradeSchema = z.object({
  id: z.number(),
  price: z.string(),
  amount: z.string(),
  takerOrMaker: z.string(),
  createdAt: z.string(),
});
export type SpotOrderTradeDto = z.infer<typeof SpotOrderTradeSchema>;

export const SpotOrderSchema = z.object({
  id: z.number(),
  externalOrderId: z.string(),
  exchangeId: z.string(),
  status: z.string(),
  pairSymbol: z.string(),
  side: z.enum(ORDER_SIDE),
  type: z.enum(ORDER_TYPE),
  amount: z.string(),
  filled: z.string(),
  filledQuote: z.string(),
  price: z.string(),
  averageFilledPrice: z.string(),
  role: z.enum(TAKER_OR_MAKER).nullable(),
  createdAt: z.string(),
  isDex: z.boolean(),
  chainId: z.string().nullable(),
  trades: z.array(SpotOrderTradeSchema),
});
export type SpotOrderDto = z.infer<typeof SpotOrderSchema>;

export const GetSpotOrderHistoryResponseSchema = z.object({
  orders: z.array(SpotOrderSchema),
  total: z.number(),
  limit: z.number(),
  offset: z.number(),
});
export type GetSpotOrderHistoryResponse = z.infer<typeof GetSpotOrderHistoryResponseSchema>;

export const GetSpotOrderHistoryParamsSchema = z.object({
  pairSymbol: z.string().optional(),
  limit: z.number().optional(),
  offset: z.number().optional(),
  /** Filter by order status: "open" (unfilled), "closed" (filled), "all" (default) */
  status: z.enum(SPOT_ORDER_STATUS_FILTER).optional(),
});
export type GetSpotOrderHistoryParams = z.infer<typeof GetSpotOrderHistoryParamsSchema>;

export const SpotTradeWithOrderInfoSchema = z.object({
  id: z.number(),
  price: z.string(),
  amount: z.string(),
  takerOrMaker: z.string(),
  createdAt: z.string(),
  orderId: z.number(),
  pairSymbol: z.string(),
  side: z.enum(ORDER_SIDE),
  exchangeId: z.string(),
  isDex: z.boolean(),
});
export type SpotTradeWithOrderInfoDto = z.infer<typeof SpotTradeWithOrderInfoSchema>;

export const GetSpotTradesResponseSchema = z.object({
  trades: z.array(SpotTradeWithOrderInfoSchema),
  total: z.number(),
  limit: z.number(),
  offset: z.number(),
});
export type GetSpotTradesResponse = z.infer<typeof GetSpotTradesResponseSchema>;

export interface GetSpotTradesParams {
  pairSymbol?: string;
  limit?: number;
  offset?: number;
}
